/**
 * @file app.component.ts
 * @description a root app component
 */
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';

import { environment } from '@root/environments/environment';
import { LoaderService, LogService } from '@core/services';
import { APP_VERSION, BRAND_CONFIG } from '@core/injection-tokens';
import { BrandConfig } from '@models/interfaces';

import { AppConstants } from './app.constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private readonly loaderService: LoaderService,
    private readonly router: Router,
    private logService: LogService,
    @Inject(APP_VERSION) private readonly AppVersion: string,
    @Inject(BRAND_CONFIG) private readonly BrandConfig: BrandConfig,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.loaderService.show();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loaderService.hide();
      }
    });
  }

  public ngOnInit(): void {
    this.setLog();
    this.hideGlobalLoader();
    this.logService.log('[AppComponent] App Version & Environment: ' + this.AppVersion);
    this.logService.log('[AppComponent] Brand Config.: ' + JSON.stringify(this.BrandConfig));
  }

  private hideGlobalLoader(): void {
    // Hide the global load on application initialization
    const loader = this.document.getElementById(AppConstants.GLOBAL_LOADER_ID) as HTMLElement;
    loader.style.display = 'none';
  }

  /**
   * @description Enable logging in non-prod env only
   */
  public setLog(): void {
    if (!environment.production) {
      this.logService.enableLogging();
    }
  }
}
